import styled from 'styled-components'

export const CheckBoxContainer = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  /* height: 42px; */
  margin: 0;
  margin-left: -9px;
  cursor: pointer;
  &:first-of-type {
    margin-top: 15px;
  }
  &:last-of-type {
    margin-bottom: 15px;
  }
  & p {
    /* height: 42px; */
    margin: 0;
  }
`
